<template>
  <form @submit.prevent="submit()">
    <div class="field">
      <p
        class="control has-icons-left has-icons-right"
        :class="{ 'is-loading': loading }"
      >
        <input
          :disabled="loading"
          :id="internalId"
          name="search"
          :value="value"
          @input="
            submitted ? (submitted = false) : false;
            $emit('input', $event.target.value);
          "
          :class="{
            'is-warning': !submitted && !loading,
            'is-success': submitted && !loading,
            'is-info': loading,
          }"
          class="input is-rounded"
          type="search"
          placeholder="Search"
          autocomplete="off"
        />
        <span class="icon is-small is-left">
          <i class="mdi mdi-magnify"></i>
        </span>

        <transition v-if="showError" name="slide-fade-ddl">
          <span class="help is-danger">
            The search must be at least {{ minLength }} characters.
          </span>
        </transition>
      </p>
    </div>
  </form>
</template>

<style lang="css" scoped>
.control.is-loading::after {
  border-color: transparent transparent hsl(204, 86%, 53%) hsl(204, 86%, 53%) !important;
}
</style>

<script>
import { focus, select, getId } from "@/utils/document";

export default {
  props: [
    "loading",
    "value",
    "selectOnSubmit",
    "id",
    "focus",
    "css",
    "minLength",
  ],

  data() {
    return {
      submitted: true,
      internalId: getId(),
      showError: false,
    };
  },
  created() {
    if (this.id) this.internalId = this.id;
  },
  mounted() {
    if (this.focus) focus(this.internalId);
  },
  methods: {
    submit(e) {
      if (this.minLength && this.value.trim().length < this.minLength) {
        this.showError = true;
        return;
      } else this.showError = false;

      this.submitted = true;
      this.$emit("submit", this.value.trim());

      if (this.selectOnSubmit) {
        this.$nextTick(() => {
          select(this.internalId);
        });
      }
    },
  },
};
</script>
